export default "__VITE_ASSET__5AAK9KFH__"